import { useState } from 'react';
import { homepageFAQ } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">
            关于火影同人创作与本站的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {homepageFAQ.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <h4 className="font-medium text-sm text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${
                  openIndex === index ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}